export const ATM_WITHDRAWAL = 'pindebit.atm.withdrawal';
export const PINDEBIT = 'pindebit';
export const AUTHORIZATION = 'authorization';
export const DOMESTIC_ENABLED = 'domestic_enabled';
export const INTERNATIONAL_ENABLED = 'international_enabled';
